<span class="example-pizza-party" style="display: flex; justify-content: center;align-items: center;">
  Copied
</span>
